export default __webpack_public_path__ + "static/landing-experience-light-01f6a7bb429cdc3f004dcce061bc29a8c3a5a5a10cf3d2f21f6d1568206adbb5.png";